export const SessionSymbol = Symbol('session');
